// extracted by mini-css-extract-plugin
export default {"tooltip-wrapper":"Tooltip_tooltip-wrapper__ehoux","tooltip":"Tooltip_tooltip__R+nhF","arrow":"Tooltip_arrow__f0xyX"};